import Action from 'redux/helpers/createAction'
const name = 'locales'

export const getLocales = Action(name + '/GET_LOCALES')
export const getLocalesSuccess = Action(name + '/GET_LOCALES_SUCCESS',
  (locales) => ({ locales })
)
export const getLocalesFailure = Action(name + '/GET_LOCALES_ERROR',
  (error) => ({ error })
)
